import React, { useState, useEffect } from "react";
import * as pdfjs from "pdfjs-dist";
// import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer';
import { Fullscreen2DLayout } from "../layout/Fullscreen2DLayout";
import { IconButton } from "../input/IconButton";
import { ReactComponent as CloseIcon } from "../icons/Close.svg";
import styles from "./IframeLinkModal.scss";
import styles2D from "./2d-media.scss";
import classNames from "classnames";
import { MediaLoader } from "./MediaLoader";
import PropTypes from "prop-types";

export function PDF2DView({ close, src, sidebar, name }) {
  const [loading, setLoading] = useState(true);
  pdfjs.GlobalWorkerOptions.workerSrc =
    require("!!file-loader?outputPath=assets/js&name=[name]-[hash].js!pdfjs-dist/build/pdf.worker.min.js").default;

  function calculateViewportHeight(viewportWidth, pageWidth, pageHeight) {
    // Calculate the aspect ratio of the PDF page
    const aspectRatio = pageWidth / pageHeight;

    // Calculate the height based on the desired width (1200px)
    const viewportHeight = viewportWidth / aspectRatio;

    return viewportHeight;
  }

  async function initViewer() {
    const pdfUrl = src; // Replace with the URL or path to your PDF file
    const pdfDocument = await pdfjs.getDocument(pdfUrl).promise;
    createSinglePageViewer(pdfDocument);
    setLoading(false);
  }

  // Function to create the single-page viewer
  function createSinglePageViewer(pdfDocument) {
    const pdfInstance = pdfDocument;
    const totalPages = pdfDocument.numPages;
    const pdfContainer = document.getElementById("viewerContainer");
    if (pdfContainer) pdfContainer.innerHTML = "";
    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
      renderPage(pageNumber, pdfContainer, pdfInstance);
    }
  }

  function renderPage(pageNumber, pdfContainer, pdfInstance) {
    pdfInstance.getPage(pageNumber).then(page => {
      const MAX_LENGTH_PDF = sidebar ? 800 : 1200;
      const viewportWidth = window.innerWidth < MAX_LENGTH_PDF ? window.innerWidth : MAX_LENGTH_PDF;
      const scale = viewportWidth / page.getViewport({ scale: 1 }).width;
      const viewportHeight = calculateViewportHeight(
        viewportWidth,
        page.getViewport({ scale }).width,
        page.getViewport({ scale }).height
      );
      const viewport = page.getViewport({ scale, height: viewportHeight });

      // Create a canvas element for the page
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      pdfContainer?.appendChild(canvas);

      // Render the page on the canvas
      page.render({ canvasContext: context, viewport }).promise.then(() => {
        if (pageNumber === pdfInstance.numPages) {
          // Apply margin-bottom to the last page's canvas
          canvas.style.marginBottom = "45px";
        }
      });
    });
  }

  useEffect(() => {
    initViewer();
    return () => {
      document.getElementById("viewerContainer").innerHTML = "";
    };
  }, []);

  const onClose = () => {
    close();
  };
  return (
    <>
      <Fullscreen2DLayout
        className={classNames(styles.layout, sidebar ? "sidebar" : "", "transparency")}
        contentClassName={classNames(styles.content, styles2D.layout)}
        headerClassName={styles.header}
        headerCenter={<div className={styles2D.headerTitle}>{name}</div>}
        headerRight={
          <IconButton onClick={onClose}>
            <CloseIcon fill="white" />
          </IconButton>
        }
      >
        {loading && <MediaLoader inlineLoading={true} className={styles2D.mediaLoader} />}
        <div className={styles2D.pdf} id="viewerContainer" style={{ position: "absolute" }}></div>
      </Fullscreen2DLayout>
    </>
  );
}

PDF2DView.propTypes = {
  close: PropTypes.func,
  src: PropTypes.string,
  sidebar: PropTypes.bool,
  name: PropTypes.string
};
